import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import StockoutproducttoproductorderFilterCriteria from './StockoutproducttoproductorderFilterCriteria'
import StockoutproducttoproductorderList from './StockoutproducttoproductorderList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './StockoutproducttoproductorderAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setStockoutproducttoproductorderDashboardStockoutproducttoproductorderList } from '../../store/slice/ManufSlice';

export default function StockoutproducttoproductorderListView({setShowEdit,setStockoutproducttoproductorderId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.stockoutproducttoproductorderDashboard);   

    const [filteredStockoutproducttoproductorderList, setFilteredStockoutproducttoproductorderList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { stockoutproducttoproductorderDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList.length>-1){
        setFilteredStockoutproducttoproductorderList(stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList);
        transformToCardFormat(stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList, setCardList);
      }
    },[stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList])

    useEffect(()=>{
          transformToCardFormat(filteredStockoutproducttoproductorderList, setCardList);
      },[filteredStockoutproducttoproductorderList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.stockoutproductid==='' && filterCriteria.productorderid==='' && filterCriteria.orderid==='' && filterCriteria.qty==='' && filterCriteria.stockoutreqid==='' ){
            setFilteredStockoutproducttoproductorderList(stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList);
            transformToCardFormat(stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList, setCardList);

        } else {
            setFilteredStockoutproducttoproductorderList(
                stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList
                    .filter(stockoutproducttoproductorder=> stockoutproducttoproductorder.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(stockoutproducttoproductorderDashboard.filteredStockoutproducttoproductorderList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <StockoutproducttoproductorderList
                    setShowEdit={setShowEdit}
                    setStockoutproducttoproductorderId = {setStockoutproducttoproductorderId}
                    tableList={filteredStockoutproducttoproductorderList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}